/**
 * Aus URL und Objektwahl wird die Abfrage des Verlaufs. Jede bisher gültige URL ergibt dieselbe
 * Abfrage wie vorher: ein Einzelwert wird eine Liste mit einem Eintrag, das Objekt geht als
 * `propertyGroupIds`, ein gewähltes Apartment ersetzt die Apartments der Objektwahl.
 */
import type { DynamicPricingDecisionOutcome, DynamicPricingHistoryQuery } from '@/shared/api';
import { historyView, listOf, type DynamicPricingHistorySearch } from './historyUrlState';

const list = <T extends string = string>(value: string | undefined) => {
  const values = listOf(value);
  return values.length ? (values as T[]) : undefined;
};

export function historyQuery(
  search: DynamicPricingHistorySearch,
  scope: { groupId: string | null; propertyIds: string[] | null; apartment?: string },
): DynamicPricingHistoryQuery {
  return {
    view: historyView(search.view),
    propertyGroupIds: scope.groupId ? [scope.groupId] : undefined,
    propertyIds: scope.apartment ? [scope.apartment] : scope.propertyIds,
    stayFrom: search.stayFrom,
    stayTo: search.stayTo,
    decisionFromUtc: search.decisionFrom,
    decisionToUtc: search.decisionTo,
    triggers: list(search.trigger),
    outcomes: list<DynamicPricingDecisionOutcome>(search.outcome),
    publicationStatuses: list(search.publicationStatus),
    publicationCreatedFromUtc: search.publicationCreatedFrom,
    publicationCreatedToUtc: search.publicationCreatedTo,
    exposureConfirmedFromUtc: search.exposureConfirmedFrom,
    exposureConfirmedToUtc: search.exposureConfirmedTo,
    exposureKinds: list<'Base' | 'ChannelModifier'>(search.exposureKind),
    strategyProfileVersionId: search.profileVersion,
    configurationVersionId: search.configurationVersion,
  };
}
